import { TitulosResponsive } from './TitulosResponsive';
import { DescripcionesResponsive } from './DescripcionesResponsive';
import { AnchorModel, Link } from '@bpba/ui-components';

export class Banner extends AnchorModel {
  static IMG_GRANDE_SUFIJO = '_L';
  static IMG_MEDIANA_SUFIJO = '_M';
  static IMG_REDUCIDA_SUFIJO = '_S';
  static IMG_EXTRA_REDUCIDA_SUFIJO = '_XS';
  titulos?: TitulosResponsive;
  rutaImagen?: string;
  textoCallToAction?: string;
  descripciones?: DescripcionesResponsive;
  fechaCuentaRegresiva?: string;

  constructor(orden: number = 0, enlace?: Link, titulos?: TitulosResponsive, rutaImagen?: string, textoCallToAction?: string, descripciones?: DescripcionesResponsive, fechaCuentaRegresiva?: string) {
    super(orden, undefined, enlace, undefined);
    this.titulos = titulos;
    this.rutaImagen = rutaImagen;
    this.textoCallToAction = textoCallToAction;
    this.descripciones = descripciones;
    this.fechaCuentaRegresiva = fechaCuentaRegresiva;
  }

  rutaImagenLarge(): string {
    return this.rutaImagen ? this.rutaImagen + Banner.IMG_GRANDE_SUFIJO : '';
  }
  rutaImagenMedium(): string {
    return this.rutaImagen ? this.rutaImagen + Banner.IMG_MEDIANA_SUFIJO : '';
  }
  rutaImagenSmall(): string {
    return this.rutaImagen ? this.rutaImagen + Banner.IMG_REDUCIDA_SUFIJO : '';
  }
  public rutaImagenExtraSmall(): string {
    return this.rutaImagen ? this.rutaImagen + Banner.IMG_EXTRA_REDUCIDA_SUFIJO : '';
  }

  static fromJsonObject(json: any): Banner {
    return new Banner(
      json?.orden,
      Link.fromJsonObject(json?.enlace),
      new TitulosResponsive(json?.titulos?.titleDesktop, json?.titulos?.titleTablet, json?.titulos?.titleMobile),
      json?.rutaImagen,
      json?.textoCalltoAction
    );
  } 

}

